module.exports = __webpack_public_path__ + "static/media/floorPlanFloor3.74c55ed0.png";